<script>
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from 'svelte';
    export let popupMsg = "";
    export let popupShow = false;
    export let title = $_('popup.title');

    const dispatch = createEventDispatcher();

    function close()  {
        dispatch('closePopup', {});
    }

</script>

{#if popupShow}
    <div class="popup fixed top-0 left-0 m-auto w-full h-full bg-stone-300/[.6] flex items-center justify-center flex-col">
        <div class="bg-white rounded-[5px] px-5 py-5 w-[400px] text-[14px] relative text-center">
            <h4 class="text-[16px]">{title}</h4>
            <div class="text-center">
                {popupMsg}
            </div>
            <div class="bg-black text-white rounded-[5px] p-2 mt-1 cursor-pointer text-center" on:click={()=>close()}>{$_('status.close')}</div>  
        </div>

    </div>
{/if}
